<template>
  <div class="tw:flex tw:flex-col tw:gap-2" data-testid="brand-colours">
    <span class="tw:text-13 tw:font-medium tw:text-gray-700">{{ $t('brand.colours') }}</span>

    <div class="tw:flex tw:flex-wrap tw:gap-2.5">
      <ColorChip
        :label="$t('brand.colour_primary')"
        v-model="primaryColor"
        :removable="!!primaryColor"
        @remove="primaryColor = ''" />
      <ColorChip
        :label="$t('brand.colour_accent')"
        v-model="accentColor"
        :removable="!!accentColor"
        @remove="accentColor = ''" />
    </div>
  </div>
</template>

<script setup lang="ts">
/** The primary and accent brand colour chips, shared by the registration company step and the company settings. */
import ColorChip from '@/components/generic/ColorChip.vue';
import { useBrandColors } from '@/composables/useBrandColors';
import type { BrandColor } from '@/types/company';

/* ----------------------------------- STATE ---------------------------------- */
const colors = defineModel<BrandColor[]>({ required: true });

const { primaryColor, accentColor } = useBrandColors(colors);
</script>
